import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  compareArrays<T extends string | number>(a: T[], b: T[]): boolean {
    if (!a || !b || a.length !== b.length) return false;
    const setA = new Set(a);
    return b.every((item) => setA.has(item));
  }
}
